module.exports = __webpack_public_path__ + "static/media/haiwaifengongsirenyuanguanli2.7f67f51a.png";